var map = {
	"./Espressokanne.svg": 394,
	"./Filterkaffeemaschine.svg": 395,
	"./Halbautomat.svg": 396,
	"./Handfilter.svg": 397,
	"./Kapselmaschine.svg": 398,
	"./Padmaschine.svg": 399,
	"./Siebstempelkanne.svg": 400,
	"./Vollautomat.svg": 401,
	"./arrow-back.svg": 402,
	"./arrow-forward.svg": 403,
	"./b1_favs_share.png": 969,
	"./b1_haushalt_geraete_share.png": 970,
	"./b1_import_export_share.png": 971,
	"./b1_kaffee_in_zahlen_share.png": 972,
	"./b1_kaffee_preis_share.png": 973,
	"./b1_prod_vis_share.png": 974,
	"./b1_production_map_share.png": 975,
	"./coldBrew.svg": 404,
	"./cover/kaffee_in_zahlen_2012.jpg": 976,
	"./cover/kaffee_in_zahlen_2013.jpg": 977,
	"./cover/kaffee_in_zahlen_2014.jpg": 978,
	"./cover/kaffee_in_zahlen_2015.jpg": 979,
	"./cover/kaffee_in_zahlen_2016.jpg": 980,
	"./cover/kaffee_in_zahlen_2017.jpg": 981,
	"./cup.svg": 405,
	"./partners/Statista_Logo.svg": 982,
	"./partners/Statista_Logo_gray.svg": 983,
	"./partners/Statista_Logo_white.svg": 984,
	"./partners/Tchibo_Logo.svg": 985,
	"./partners/Tchibo_Logo_gray.svg": 986,
	"./partners/Tchibo_Logo_white.svg": 987,
	"./partners/logo-brandeins-wissen.svg": 988,
	"./partners/logo-brandeins-wissen_gray.svg": 989,
	"./partners/logo-brandeins-wissen_white.svg": 990,
	"./touch.svg": 236
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1148;



//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images ^\.\/.*$
// module id = 1148
// module chunks = 0